export const fontSizes = {
	xs: "50px",
	lg: "35px",
	md: "20px",
	sm: "14px",
};
